import { AfterViewInit, Component, Input, OnInit } from "@angular/core";

interface InstagramEmbedInterface {
  embed: string;
}

interface InstagramInterface {
  items: InstagramEmbedInterface[];
  template: string;
}

@Component({
  selector: "app-instagram",
  templateUrl: "./instagram.component.html",
  styleUrls: ["./instagram.component.scss"],
})
export class InstagramComponent implements OnInit, AfterViewInit {
  columnCount: number;

  @Input() node: InstagramInterface;

  constructor() {}

  ngOnInit() {
    if (this.node?.template)
      this.columnCount = 12 / parseInt(this.node.template.replace("grid-", ""));

    this.node.items.forEach((item) => {
      item.embed = this.generateIFrame(item.embed);
    });
  }

  ngAfterViewInit() {
    if (typeof window !== "undefined" && window?.instgrm)
      window.instgrm.Embeds.process();
  }

  /**
   * Generate Instagram Embed iframe HMTL
   *
   * @param {string} embedId
   * @param {number} colCount
   * @returns
   * @memberof InstagramComponent
   */
  generateIFrame(embed: string) {
    return `<div class="iframe-wrapper">${embed}</div>`;
  }
}
